module.exports = __webpack_public_path__ + "static/media/hossein.fd665593.png";